import React, { useState } from 'react';
import { useTranslation } from 'react-i18next'; // I18N
import Grid from "@mui/material/Grid";
import SimpleReactValidator from "simple-react-validator";
import { toast } from "react-toastify";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { Link, useNavigate } from "react-router-dom";
import Logo from '../../images/logo2.png';

import './style.scss';

const ForgotPassword = (props) => {
    const { t } = useTranslation(); // I18N
    const push = useNavigate()

    const [value, setValue] = useState({
        email: '',
    });

    const changeHandler = (e) => {
        setValue({ ...value, [e.target.name]: e.target.value });
        validator.showMessages();
    };

    const [validator] = React.useState(new SimpleReactValidator({
        className: 'errorMessage'
    }));

    const submitForm = (e) => {
        e.preventDefault();
        if (validator.allValid()) {
            setValue({
                email: '',
            });
            validator.hideMessages();
            toast.success(t('forgot.success'));
            push('/login');
        } else {
            validator.showMessages();
            toast.error(t('forgot.emptyField'));
        }
    };
    return (
        <Grid className="loginWrapper">

            <Grid className="loginForm">
                <div style={{display:"flex", justifyContent:"center"}}>
      <img
    src={Logo}  
    alt="Login Banner"
    className="loginImage"  
    style={{
        width:"160px",
        alignSelf:"center",
        height:"80px",
        
    }}      
  />
</div>
                <h2>{t('forgot.title')}</h2>
                <p>{t('forgot.subtitle')}</p>
                <form onSubmit={submitForm}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <TextField
                                className="inputOutline"
                                fullWidth
                                placeholder={t('forgot.email')}
                                value={value.email}
                                variant="outlined"
                                name="email"
                                label={t('forgot.email')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onBlur={(e) => changeHandler(e)}
                                onChange={(e) => changeHandler(e)}
                            />
                            {validator.message('email', value.email, 'required|email')}
                        </Grid>
                        <Grid item xs={12}>
                            <Grid className="formFooter">
                                <Button fullWidth className="cBtn cBtnLarge cBtnTheme" type="submit">{t('forgot.resend')}</Button>
                            </Grid>
                         
                            <p className="noteHelp">{t('forgot.alreadyHave')} <Link to="/login">{t('forgot.returnToSignIn')}</Link>
                            </p>
                        </Grid>
                    </Grid>
                </form>
                <div className="shape-img">
                   <i className="fa-solid fa-hexagon"></i>
                </div>
            </Grid>
        </Grid>
    )
};

export default ForgotPassword;